/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_References_DescInputs */

const en_wc_tour_references_desc = /** @type {(inputs: Wc_Tour_References_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tables of contents, footnotes, citations in APA, MLA, Chicago or IEEE, index and captions.`)
};

/**
* | output |
* | --- |
* | "Tables of contents, footnotes, citations in APA, MLA, Chicago or IEEE, index and captions." |
*
* @param {Wc_Tour_References_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_references_desc = /** @type {((inputs?: Wc_Tour_References_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_References_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_references_desc(inputs)
});
export { wc_tour_references_desc as "wc.tour.references.desc" }